<template>
  <div class="component-select-member">
    <div :class="showDrawer ? 'component-select-box is-select' : 'component-select-box'" @click="onSelect">
      <div class="left" v-if="isBatchImport">
        <div class="tag select-tag-box">
          <div class="phone">批量导入会员+{{form[name].length}}</div>
        </div>
      </div>
      <div class="left" v-else-if="selectedData.length > 0">
        <div class="tag select-tag-box">
          <div class="phone">{{ selectedData[0].phone }}</div>
          <i class="el-icon-error" @click.stop="onClearFirst"></i>
        </div>
        <div class="tag omit-tag" v-if="selectedData.length > 1">+{{ selectedData.length - 1 }}</div>
      </div>
      <div v-else class="left placeholder">
        <span>请选择会员</span>
        <span v-if="maxLength">（最多可选{{maxLength}}条）</span>
      </div>
      <div class="right">
        <i v-if="!isBatchImport" :class="showDrawer ? 'el-icon-arrow-down up' : 'el-icon-arrow-down'"></i>
      </div>
    </div>
    <el-select style="display:none;" multiple v-model="form[name]"/>
    <el-drawer
      :visible="showDrawer"
      direction="rtl"
      size="50%"
      @close="() => this.showDrawer = false"
    >
      <template slot="title">
        <div style="font-weight: 600; color: #333;">
          <span>请选择会员</span>
          <span v-if="maxLength">（最多可选{{maxLength}}条）</span>
        </div>
      </template>
      <div class="drawer-box">
        <div class="drawer-main-box">
          <div class="search-box">
            <el-form ref="searchForm" :model="searchForm" label-width="80px" :inline="true">
              <el-form-item label="手机号" >
                <el-input type="text" v-model="searchForm.phone" placeholder="请输入手机号"/>
              </el-form-item>
            </el-form>
            <div class="search-btn-box">
              <el-button type="primary" @click="onSearch" class="mr10">查询</el-button>
              <el-button @click="onReset">重置</el-button>
            </div>
          </div>
          <div class="table-box">
            <el-table
              :data="tableData"
              style="width: 100%"
              v-loading="loading"
              empty-text="暂无数据"
              @select="selectTable"
              @select-all="selectTable_all"
              :header-cell-style="{ background:'#F2F3F5',height:'50px',border: '0'}"
              :row-key="row => row.id"
              ref="table"
            >
              <el-table-column type="selection" align="center" width="55" :selectable="onSelectable"></el-table-column>
              <el-table-column prop="phone" label="手机号">
                <template slot-scope="scope" >
                  <span :key="phoneKey">{{ scope.row.phone_show || scope.row.phone }}</span>
                  <auth-button auth="user:phone:read">
                    <el-button v-if="scope.row.phone" class="look-phone-btn" type="text" @click="onLookPhone(scope.row, scope.$index)">
                      {{ scope.row.phone_show ? '隐藏' : '查看' }}
                    </el-button>
                  </auth-button>
                </template>
              </el-table-column>
              <el-table-column prop="levelName" label="会员等级"></el-table-column>
              <el-table-column prop="platform" label="注册来源"></el-table-column>
            </el-table>
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10]"
              :page-size="limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import { api_getListMember } from '@/api/member'
import { api_getUserPhone } from '@/api/common'
import aes from '@/common/aes.js'

export default {
  name: "ConponentSelectMember",
  components: { Search, Table, AuthButton },
  props: {
    form: {
      type: Object,
      default() {
        return {}
      },
    },
    name: {
      type: String,
      default() {
        return 'userIds'
      },
    },
    maxLength: {
      type: Number,
      default() {
        return 0
      },
    },
    selected: {
      type: Array,
      default() {
        return []
      },
    },
    isBatchImport: Boolean
  },
  data() {
    return {
      showDrawer: false,
      searchForm: {},
      loading: false,

      total: 0,
      currentPage: 1,
      offset: 0,
      limit: 10,

      selectedData: [], // 选中项row数据
      selectedIds: [], // 选中项id数组
      tableData: [],
      phoneKey: false,
      onSelectable: (row) => {
        return !this.maxLength || this.selectedIds.length < this.maxLength || this.selectedIds.indexOf(row.id) >= 0
      }
    };
  },
  created() {
    if(this.selected.length >0){
      this.selectedData = this.selected
      this.selectedIds = this.selectedData.map(item => item.id)
    }
    this.getTableData() // 获取表格数据
  },
  mounted() {
  },
  methods: {
    // 点击选择框
    onSelect() {
      if(!this.isBatchImport){
        this.showDrawer = true
        this.getTableData()
      }
    },

    // 获取表格数据
    async getTableData() {
      this.loading = true
      const params = {
        ...this.searchForm,
        offset: this.offset,
        limit: this.limit,
      }
      const data = await api_getListMember(params)
      this.tableData = data.list || []
      this.total = data.count
      this.loading = false
      this.handleEchoSelect() // 回显选中项
    },

    // 回显选中项
    handleEchoSelect() {
      if (this.showDrawer) {
        let selectRow = this.tableData.filter(item => this.selectedIds.indexOf(item.id) >= 0)
        setTimeout(() => {
          selectRow.forEach(item => {
            this.$refs.table.toggleRowSelection(item, true);
          })
        }, 100)
      }
    },

    // 表格单选选择
    selectTable(selection, row) {
      let curRowIndex = selection.findIndex(item => item.id == row.id)
      if (curRowIndex >= 0) {
        // 选择
        this.selectedData.push(row)
      } else {
        // 取消选择
        this.selectedData = this.selectedData.filter(item => item.id !== row.id)
      }
      this.selectedIds = this.selectedData.map(item => item.id)
    },

    // 表格全选选择
    selectTable_all(selection) {
      if (selection.length) {
        // 全选
        let curRow = this.tableData.filter(item => this.selectedIds.indexOf(item.id) < 0)
        this.selectedData = [...this.selectedData, ...curRow]
      } else {
        // 取消全选
        let curTableIds = this.tableData.map(item => item.id)
        this.selectedData = this.selectedData.filter(item => curTableIds.indexOf(item.id) < 0)
      }
      this.selectedIds = this.selectedData.map(item => item.id)

    },

    // 查询
    onSearch() {
      this.offset = 0
      this.currentPage = parseInt(this.offset / this.limit) + 1
      this.getTableData()
    },

    // 重置
    onReset() {
      this.searchForm = {}
    },

    // 删除第一项
    onClearFirst() {
      this.selectedData.shift()
      this.selectedIds.shift()
    },

    handleSizeChange (limit) {
      this.limit = limit
      this.getTableData()
    },

    handleCurrentChange (val) {
      this.offset = (val - 1) * this.limit
      this.currentPage = parseInt(this.offset / this.limit) + 1
      this.getTableData()
    },

    // 点击查看手机号
    async onLookPhone(row, index) {
      try {
        if (row.phone_show) {
          delete this.tableData[index].phone_show
        } else {
          const {phone} = await api_getUserPhone({id: row.id})
          this.tableData[index].phone_show = aes.decrypt(phone)
        }
      } catch (error) {}
      this.phoneKey = !this.phoneKey
    },
  },
  watch: {
    selectedIds: function() {
      this.$emit('change', this.selectedIds)
    },
  }
};
</script>

<style lang="scss" scoped>
.component-select-member {

  .component-select-box {
    width: 368px;
    height: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f2f3f5;
    border-radius: 2px;
    border: 1px solid #f2f3f5;
    padding: 0 15px;

    &.is-select {
      background-color: #fff;
      border-color: #05C8AF;
    }
    .left {
      display: flex;

      &.placeholder {
        color: #999;
      }
      .tag {
        height: 22px;
        border-radius: 4px;
        border: 1px solid #ddd;
        display: flex;
        align-items: center;
        padding: 0 10px;
        color: #999;
        font-size: 12px;
        margin-right: 10px;

        &.select-tag-box {
          .el-icon-error {
            margin-left: 5px;
            font-size: 14px;
            color: #bbb;

            &:hover {
              color: #999;
              cursor: pointer;
            }
          }
        }
      }
    }

    .right {
      .el-icon-arrow-down {
        transform: rotate(0deg);

        &.up {
          transform: rotate(180deg);
        }
      }
    }
  }

  .drawer-box {
    padding: 0 20px;
    padding-bottom: 74px;
    height: 100%;
    position: relative;

    .drawer-main-box {
      max-height: calc(100vh - 86px);
      overflow: auto;
      .search-box {
        border-bottom: 1px solid #eee;
        padding-bottom: 10px;
        display: flex;
        justify-content: space-between;

        .search-btn-box {

          .el-button {
            min-width: 80px !important;
          }
        }
      }
    }

  }
}
</style>
